export const Events = {};

export const toastrEvents = {
  WebNotified: 'WebNotified',
};

export const ClientDataRequestEvents = {
  ClientDataRequestSaved: 'Portal.PublishedLanguage.Events.ClientDataRequest.ClientDataRequestSaved',
  ClientDataRequestSaveFailed: 'Portal.PublishedLanguage.Events.ClientDataRequest.ClientDataRequestSaveFailed',
  ClientDataRequestStatusChanged: 'PublishedLanguage.Events.ClientDataRequest.ClientDataRequestStatusChanged',
  ClientDataRequestStatusChangeFailed: 'PublishedLanguage.Events.ClientDataRequest.ClientDataRequestStatusChangeFailed',
};

export const RequestEvents = {
  DelegateSaved: 'PublishedLanguage.Events.Request.DelegateSaved',
  DelegateSaveFailed: 'PublishedLanguage.Events.Request.DelegateSaveFailed',
  RequestSaved: 'PublishedLanguage.Events.Request.RequestSaved',
  RequestSaveFailed: 'PublishedLanguage.Events.Request.RequestSaveFailed',
  DelegateRemoved: 'PublishedLanguage.Events.Request.DelegateRemoved',
  DelegateRemoveFailed: 'PublishedLanguage.Events.Request.DelegateRemoveFailed',
  AssetDocumentRequestStatusChanged: 'PublishedLanguage.Events.Request.AssetDocumentRequestStatusChanged',
  AssetDocumentRequestStatusChangeFailed: 'PublishedLanguage.Events.Request.AssetDocumentRequestStatusChangeFailed',
};

export const UserEvents = {
  UserStatusChanged: 'TenantService.PublishedLanguage.Events.TAP.UserStatusChanged',
  UserStatusChangeFailed: 'TenantService.PublishedLanguage.Events.TAP.UserStatusChangeFailed',
  UserDeleted: 'Portal.PublishedLanguage.Events.User.PortalUserDeleted',
  UserDeleteFailed: 'Portal.PublishedLanguage.Events.User.PortalUserDeleteFailed',
  UserSaved: 'TenantService.PublishedLanguage.Events.TAP.UserSaved',
  UserSaveFailed: 'TenantService.PublishedLanguage.Events.TAP.UserSaveFailed',
};

export const NotificationEvents = {
  NotificationsMarkedAsRead: 'PublishedLanguage.Task.Events.NotificationsMarkedAsRead',
  NotificationsMarkedAsReadFailed: 'Portal.PublishedLanguage.Events.User.NotificationsMarkedAsReadFailed',
};

export const LanguageEvents = {
  LanguageFileSaved: 'TenantService.PublishedLanguage.Events.TAP.LanguageFileSaved',
  LanguageFileSaveFailed: 'TenantService.PublishedLanguage.Events.TAP.LanguageFileSaveFailed',
  DictionaryTranslationSaved: 'TenantService.PublishedLanguage.Events.TAP.DictionaryTranslationSaved',
  DictionaryTranslationSaveFailed: 'TenantService.PublishedLanguage.Events.TAP.DictionaryTranslationSaveFailed',
};

export const ContractModificationRequestEvents = {
  ContractModificationRequestSaved: 'PublishedLanguage.Events.Request.ContractModificationRequestSaved',
  ContractModificationRequestStatusChanged: 'PublishedLanguage.Events.Request.ContractModificationRequestStatusChanged',
  ContractModificationRequestStatusChangeFailed:
    'PublishedLanguage.Events.Request.ContractModificationRequestStatusChangeFailed',
};

export const InvoiceEvents = {
  InvoiceFileSaved: 'gRpc.PublishedLanguage.Events.Invoice.InvoiceFileSaved',
  GenerateInvoiceFileFailed: 'PublishedLanguage.Events.Invoice.GenerateInvoiceFileFailed',
  InvoiceFileSaveFailed: 'gRpc.PublishedLanguage.Events.Invoice.InvoiceFileSaveFailed',
};

export const RequestCommentEvents = {
  RequestCommentSaved: 'PublishedLanguage.Events.Request.RequestCommentSaved',
};

export const RequestDocumentsEvents = {
  RequestDocumentsLinked: 'PublishedLanguage.Events.Request.RequestDocumentsLinked',
  DocumentsDownloadDateMarked: 'PublishedLanguage.Events.Request.DocumentsDownloadDateMarked',
};

export const DocumentExport = {
  ContractPaymentScheduleExported: 'Portal.PublishedLanguage.Events.DocumentExport.ContractPaymentScheduleExported',
  ContractPaymentScheduleExportFailed:
    'Portal.PublishedLanguage.Events.DocumentExport.ContractPaymentScheduleExportFailed',
  ContractPaymentScheduleFileSaved: 'gRpc.PublishedLanguage.Events.PaymentSchedule.PaymentScheduleFileSaved',
  ContractPaymentScheduleFileSaveFailed: 'gRpc.PublishedLanguage.Events.PaymentSchedule.PaymentScheduleFileSaveFailed',
  SpecialOfferExported: 'Portal.PublishedLanguage.Events.DocumentExport.SpecialOfferExported',
};

export const EmailsEvents = {
  EmailXRequestTypesSaved: 'Portal.PublishedLanguage.Events.Emails.EmailXRequestTypesSaved',
  EmailXRequestTypesSaveFailed: 'Portal.PublishedLanguage.Events.Emails.EmailXRequestTypesSaveFailed',
  EmailDeleted: 'Portal.PublishedLanguage.Events.Emails.EmailDeleted',
  EmailDeleteFailed: 'Portal.PublishedLanguage.Events.Emails.EmailDeleteFailed',
};

export const CookieEvents = {
  CookieMessageConsentSaved: 'PublishedLanguage.Events.CookieConsent.PortalCookieMessageConsentSaved',
  CookieMessageConsentSaveFailed: 'PublishedLanguage.Events.CookieConsent.PortalCookieMessageConsentSaveFailed',
  CookieMessageSaved: 'Portal.PublishedLanguage.Events.Cookie.PortalCookieMessageSaved',
  CookieMessageSaveFailed: 'Portal.PublishedLanguage.Events.Cookie.PortalCookieMessageSaveFailed',
  CookieMessageDeleted: 'Portal.PublishedLanguage.Events.Cookie.PortalCookieMessageDeleted',
  CookieMessageDeleteFailed: 'Portal.PublishedLanguage.Events.Cookie.PortalCookieMessageDeleteFailed',
};

export const FAQEvents = {
  FrequentlyAskedQuestionSaved: 'Portal.PublishedLanguage.Events.FAQ.FrequentlyAskedQuestionSaved',
  FrequentlyAskedQuestionSaveFailed: 'Portal.PublishedLanguage.Events.FAQ.FrequentlyAskedQuestionSaveFailed',
  FrequentlyAskedQuestionDeleted: 'Portal.PublishedLanguage.Events.FAQ.FrequentlyAskedQuestionDeleted',
  FrequentlyAskedQuestionDeleteFailed: 'Portal.PublishedLanguage.Events.FAQ.FrequentlyAskedQuestionDeleteFailed',
  FrequentlyAskedQuestionsOrdersSaved: 'Portal.PublishedLanguage.Events.FAQ.FrequentlyAskedQuestionsOrderSaved',
  FrequentlyAskedQuestionsSaveOrdersFailed:
    'Portal.PublishedLanguage.Events.FAQ.FrequentlyAskedQuestionsSaveOrderFailed',
};

export const UserPermissionEvents = {
  UserPermissionSaved: 'PublishedLanguage.Events.User.UserPermissionSaved',
};

export const FileEvents = {
  FilePosted: 'Codecabinet.sni.FileManager.PublishedLanguage.Events',
  FilePostFailed: 'Codecabinet.sni.FileManager.PublishedLanguage.Events.FilePostFailed',
  PortalFilePosted: 'Portal.PublishedLanguage.Events.Files.PortalFilePosted',
  PortalFilePostFailed: 'Portal.PublishedLanguage.Events.Files.PortalFilePostFailed',
  FileDeleted: 'Codecabinet.sni.FileManager.PublishedLanguage.Events.FileDeleted',
  FileDeleteFailed: 'Codecabinet.sni.FileManager.PublishedLanguage.Events.FileDeleteFailed',
};

export const SpecialOfferEvents = {
  SpecialOfferSaved: 'Portal.PublishedLanguage.Events.SpecialOffer.SpecialOfferSaved',
  SpecialOfferSaveFailed: 'Portal.PublishedLanguage.Events.SpecialOffer.SpecialOfferSaveFailed',
  SpecialOfferDelete: 'Portal.PublishedLanguage.Events.SpecialOffer.SpecialOfferDeleted',
  SpecialOfferStopped: 'Portal.PublishedLanguage.Events.SpecialOffer.SpecialOfferStopped',
  SpecialOfferEngagementRecorded: 'PublishedLanguage.Events.SpecialOffer.SpecialOfferEngagementRecorded',
  SpecialOfferAlreadyRequested: 'PublishedLanguage.Events.SpecialOffer.SpecialOfferAlreadyRequested',
};

export const AssetEvents = {
  AssetDeliveryDelegateChanged: 'Portal.PublishedLanguage.Events.Asset.AssetDeliveryDelegateChanged',
  AssetDeliveryDelegateChangeFailed: 'Portal.PublishedLanguage.Events.Asset.AssetDeliveryDelegateChangeFailed',
};

export const ServiceAppointmentEvents = {
  ServicAppointmentSaved: 'Portal.PublishedLanguage.Events.Asset.ServicAppointmentSaved',
  ServicAppointmentSaveFailed: 'Portal.PublishedLanguage.Events.Asset.ServicAppointmentSaveFailed',
};
